(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_product-media-gallery"] && !Shopify.designMode) return;
  try {
    // Autoplay videos cuando entren en vista
  document.addEventListener('DOMContentLoaded', function() {
    const videos = document.querySelectorAll('media-gallery video, media-gallery iframe');
    
    // Configurar todos los videos para autoplay y muted
    videos.forEach(video => {
      if (video.tagName === 'VIDEO') {
        video.muted = true;
        video.setAttribute('playsinline', '');
        video.loop = true;
      }
    });

    // Intersection Observer para detectar cuando un video entra en vista
    const observerOptions = {
      root: null,
      rootMargin: '0px',
      threshold: 0.5
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        const media = entry.target;
        const video = media.querySelector('video');
        const deferredMedia = media.querySelector('deferred-media');
        
        if (entry.isIntersecting) {
          if (video && video.paused) {
            video.play().catch(e => console.log('Autoplay prevented:', e));
          }
          if (deferredMedia && !deferredMedia.getAttribute('loaded')) {
            deferredMedia.loadContent();
          }
        } else {
          if (video && !video.paused) {
            video.pause();
          }
        }
      });
    }, observerOptions);

    const mediaContainers = document.querySelectorAll('.product-media-container--video, .product-media-container--external_video');
    mediaContainers.forEach(container => {
      observer.observe(container);
    });

    const slideshow = document.querySelector('media-gallery [ref="slideshow"]');
    if (slideshow) {
      slideshow.addEventListener('slidechange', (e) => {
        const activeSlide = slideshow.querySelector('.slideshow__slide--active');
        const video = activeSlide?.querySelector('video');
        
        if (video) {
          video.muted = true;
          video.play().catch(e => console.log('Autoplay prevented:', e));
        }
      });
    }
  });
  } catch(e) { console.error(e); }
})();

})();
